import ApplicationController from '@app/javascript/controllers/application_controller'
import { useDispatch } from 'stimulus-use'

export default class extends ApplicationController {
  connect() {
    useDispatch(this, { eventPrefix: false })
  }

  // This method dispatches an event for calling the scrollTo method of the scroll_to_controller.js
  //
  // @param {Object} regionPointClickEvent Event including a Highcharts.Point Object
  //                                       and extra attributes such as the scroll_to attribute
  //                                       needed for this.
  dispatchEventForScrollTo(regionPointClickEvent) {
    const query = ((regionPointClickEvent.detail.point || {}).value || {}).scroll_to
    if (query) {
      this.dispatch('scroll-to.scrollTo', { scrollTo: query })
    }
  }
}
